import { TEXT_EDITOR_SET_SELECTION_FUNCTION } from './types'

export const textEditorSetSelectionFunction = (setSelection: Function) => ({
  type: TEXT_EDITOR_SET_SELECTION_FUNCTION,
  setSelection
})
